<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">

        <p-card>

            <p-menu #menuContextuelNote popup="popup" [model]="contenuMenuContextuelNote"></p-menu>

            <p-table #dtNotes [value]="notes" dataKey="noteId" tableStyleClass="tableNormale"
							autoLayout="true"  [rowHover]="true"
							[filterDelay]="0" [globalFilterFields]="['description']">
							<ng-template pTemplate="caption">
								<div class="flex align-content-center justify-content-between">
									<div>
										<span class="p-input-icon-left">
											<i class="pi pi-search"></i>
											<input pInputText type="text"
												(input)="dtNotes.filterGlobal($event.target.value, 'contains')"
												placeholder="Recherche..." />
										</span>

									</div>
									<h5 class="titreTableau m-0">Notes</h5>
									<div>
										<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
											placeholder="Colonnes..."></p-multiSelect>
									</div>
								</div>
							</ng-template>
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="date">
										<div class="flex justify-content-between align-items-center">
											Date
											<p-sortIcon field="date"></p-sortIcon>
											<p-columnFilter type="date" field="date" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="description">
										<div class="flex justify-content-between align-items-center">
											Note
											<p-sortIcon field="description"></p-sortIcon>
											<p-columnFilter type="text" field="description" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="demandeur.nom">
										<div class="flex justify-content-between align-items-center">
											Auteur
											<p-sortIcon field="demandeur"></p-sortIcon>
											<p-columnFilter type="text" field="demandeur" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="!modeApercu" style="min-width: 5rem; width: 5rem;"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-note>

								<tr>
									<td>{{note.date | date:'yyyy-MM-dd'}}</td>
									<td>{{note.description}}</td>
									<td><app-employe-avec-emplacement [employe]="note.employe"></app-employe-avec-emplacement></td>
									<td *ngIf="!modeApercu">
										<button
											*ngIf="estAutorise('temp_mec') || estAutorise('temp_mec')"
											pButton pRipple icon="pi pi-bars"
											class="p-button-secondary mr-2 boutonGrille"
											(click)="surMenuContextuelNote($event, note)"></button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="4">Aucune note.</td>
								</tr>
							</ng-template>
						</p-table>
        </p-card>
    </div>


</div>